<template>
  <div id="app">
    <!-- <keep-alive> -->
      <router-view/>
    <!-- </keep-alive> -->
  </div>
</template>

<script>
import HeaderTop from "@/components/header-top.vue";
import key from "@/api/key";

export default {
  components: {HeaderTop},
  created() {
    const names = 'logo-3,menu,close,arrow-down,gear,gear-text,play,' +
        'cute,social1,social2,social3,social4,foot-end-bg,foot-end-bg2,space,featured-button,menu-bj'
    this.$api.get('H5_common', names, key.COMMON)
  }
}
</script>

<style>
.bg {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: -1;
}
</style>
